import { ApiResponse } from "../../../types/api";
import apiClient from "../../apiClient";
import {
  GameRecord,
  GetGameRecordsParams,
  GetGameRecordsResponse,
} from "./type";

const GAME_RECORDS_ENDPOINT = "/game-records";

export const gameRecordService = {
  getGameRecords: async (
    params: GetGameRecordsParams = {},
  ): Promise<GetGameRecordsResponse> => {
    const queryParams = new URLSearchParams();

    if (params.skip !== undefined)
      queryParams.append("skip", params.skip.toString());
    if (params.limit !== undefined)
      queryParams.append("limit", params.limit.toString());
    if (params.customerId) queryParams.append("customerId", params.customerId);
    if (params.gameTableId)
      queryParams.append("gameTableId", params.gameTableId);
    if (params.managerId) queryParams.append("managerId", params.managerId);
    if (params.dealerId) queryParams.append("dealerId", params.dealerId);
    if (params.watcherId) queryParams.append("watcherId", params.watcherId);
    if (params.shift) queryParams.append("shift", params.shift);
    if (params.dateFrom) queryParams.append("dateFrom", params.dateFrom);
    if (params.dateTo) queryParams.append("dateTo", params.dateTo);

    if (params.gameIds && params.gameIds.length > 0) {
      params.gameIds.forEach((gameId) => {
        queryParams.append("gameIds", gameId);
      });
    }

    if (params.gameTableIds && params.gameTableIds.length > 0) {
      params.gameTableIds.forEach((gameTableId) => {
        queryParams.append("gameTableIds", gameTableId);
      });
    }

    const response = await apiClient.get<ApiResponse<GetGameRecordsResponse>>(
      `${GAME_RECORDS_ENDPOINT}?${queryParams.toString()}`,
    );
    return response.data.data;
  },

  getGameRecord: async (id: string): Promise<GameRecord> => {
    const response = await apiClient.get<ApiResponse<GameRecord>>(
      `${GAME_RECORDS_ENDPOINT}/${id}`,
    );
    return response.data.data;
  },
};

export type { GetGameRecordsParams, GetGameRecordsResponse, GameRecord };
